import React, { useState } from 'react';
import { Box, Heading, VStack, FormControl, Input, Button, Center, useTheme } from 'native-base';
import { Alert, Platform } from 'react-native';
import { useEnvState } from '../../../context/env';
import { useAuthDispatch, authAPI } from '../../../context/auth';
import { userAPI } from '../../../context/user';
import Confirm from '../../content/common/reusables/Confirm';
import { setSessionStorage } from '../../Constants/sessions';
import { AVATAR_SIZE } from '../../Constants';
const Login = () => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const authDispatch = useAuthDispatch();
  const envState = useEnvState();
  const handleChangeEmail = text => {
    setLoginEmail(text);
  };
  const handleChangePassword = text => {
    setLoginPassword(text);
  };
  const saveAuthProperty = (type, payload) => {
    authDispatch({
      type: type,
      payload: payload
    });
    if (Platform.OS === 'web') {
      setSessionStorage(type, payload);
    }
  };
  const doUserLogin = async () => {
    const auth = await authAPI.doUserLogin(envState.api_url, loginEmail, loginPassword);
    saveAuthProperty('SET_PLATFORM_USER', auth);
    if (auth && auth.discourseKey) {
      let avatar = auth.avatarUrl ? auth.avatarUrl : null;
      const authUserName = `${envState.discourse_api_username_prefix}.${auth.userId}`;
      const user = await userAPI.getUser(envState.base_url, authUserName, auth.discourseKey);
      if (user && user.user && user.user.id && user.user.name) {
        saveAuthProperty('SET_DISCOURSE_USER_ID', user.user.id);
        saveAuthProperty('SET_USER_NAME', user.user.name);
        saveAuthProperty('SET_MODERATOR', user.user.moderator);
        if (!avatar && user.user.avatar_template) {
          avatar = envState.base_url + user.user.avatar_template.replace(/\{size\}/, AVATAR_SIZE); // set avatar from discourse
        }

        saveAuthProperty('SET_API_KEY', auth.discourseKey);
        saveAuthProperty('SET_PLATFORM_USER_ID', auth.userId);
        saveAuthProperty('SET_AUTH_USER_AVATAR', avatar);
        saveAuthProperty('SET_USER_AUTHENTICATED', true);
      } else {
        if (Platform.OS === 'web') {
          Confirm.alert('Unable to retrieve user data');
        } else {
          Alert.alert('Unable to retrieve user data');
        }
      }
    } else {
      if (Platform.OS === 'web') {
        Confirm.alert('Unable to authenticate user');
      } else {
        Alert.alert('Unable to authenticate user');
      }
    }
  };
  return /*#__PURE__*/React.createElement(Center, {
    w: '100%',
    h: '76%',
    minH: '100vh'
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2,
    py: 8,
    w: '90%',
    maxW: 290
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 'lg',
    fontWeight: 600,
    color: colors.login.heading.text
  }, "Welcome"), /*#__PURE__*/React.createElement(Heading, {
    mt: 1,
    color: colors.login.heading.text,
    fontWeight: 'medium',
    size: 'xs'
  }, "Sign in to continue!"), /*#__PURE__*/React.createElement(VStack, {
    space: 3,
    mt: 5
  }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(FormControl.Label, null, "Email ID"), /*#__PURE__*/React.createElement(Input, {
    onChangeText: handleChangeEmail,
    value: loginEmail,
    autoCapitalize: 'none'
  })), /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(FormControl.Label, null, "Password"), /*#__PURE__*/React.createElement(Input, {
    type: 'password',
    onChangeText: handleChangePassword,
    value: loginPassword
  })), /*#__PURE__*/React.createElement(Button, {
    mt: 2,
    colorScheme: 'blueGray',
    onPress: doUserLogin
  }, "Sign in"))));
};
export default Login;
//# sourceMappingURL=Login.js.map